import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalWrapper: theme => css`
    display: flex;
    background-color: ${theme.colors.brand.primary[100]};
    padding: ${theme.spacing.xs};
    border-radius: ${theme.border.radius.md};
    gap: ${theme.spacing.md};
    margin-top: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.md};
    align-items: center;
    p {
      line-height: ${theme.spacing.sm} !important;
    }
  `,

  description: theme => css`
    margin-top: ${theme.spacing.sm};
  `,

  modalOnlyAppointment: theme => css`
    display: flex;
    gap: ${theme.spacing.xs};
    align-items: center;
    svg {
      color: ${theme.colors.brand.primary[300]};
    }
  `,

  modalIcon: () => css`
    width: 120px;
    height: 120px;
  `,

  gap: theme => css`
    display: flex;
    gap: ${theme.spacing.sm};
    flex-direction: column;
  `,

  cardsWrapper: theme => css`
    display: flex;
    gap: ${theme.spacing.xs};
    margin-top: ${theme.spacing.sm};
    justify-content: space-between;
    align-items: baseline;
  `,

  card: theme => css`
    background-color: ${theme.colors.brand.primary[300]};
    border-radius: ${theme.border.radius.md};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 88px;
    cursor: pointer;
  `,

  centered: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.xxs};
    position: relative;
  `,

  soon: theme => css`
    position: absolute;
    cursor: pointer;
    top: -10px;
    padding-left: ${theme.spacing.xxs};
    padding-right: ${theme.spacing.xxs};
    border-radius: ${theme.border.radius.xs};
    background-color: ${theme.colors.brand.primary[200]};
  `,
})

export default useStyles
